import React from "react";

import { css } from "@emotion/react";

import { CSS_COLORS } from "../../styles/styles-css-variables";
import { FooterEnd } from "./subcomponents/FooterEnd";
import { FooterTop } from "./subcomponents/FooterTop";
import { FooterSimplifiedTop } from "./subcomponents/FooterSimplifiedTop";
import { FooterData } from "@swo/storefront";

export function FooterComponentRaw(props: FooterData & { simplified?: boolean }) {
  return (
    <footer
      css={css`
        background-color: ${CSS_COLORS.GreenDark};

        width: 100%;
        display: flex;
        flex-direction: column;
      `}
    >
      {props.simplified ? (
        <FooterSimplifiedTop paymentMethods={props.paymentMethods} links={props.navigation.internal.secondary} />
      ) : (
        <FooterTop {...props} />
      )}

      <FooterEnd />
    </footer>
  );
}

export const FooterComponent = React.memo(FooterComponentRaw);
